import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "registrant card bg-transparent border border-green" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "name card-title text-start text-white fs-3" }
const _hoisted_4 = { class: "type card-subtitle text-start text-white fs-6 fw-light mb-2" }
const _hoisted_5 = { class: "dateDuration card-subtitle text-start text-white fs-6 fw-lighter" }
const _hoisted_6 = { class: "bio text-white text-start mt-3" }
const _hoisted_7 = { class: "d-flex flex-column text-start" }
const _hoisted_8 = { class: "d-flex mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt text-white fs-5" }, null, -1)
const _hoisted_10 = { class: "address align-self-center text-white ps-2 m-0" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "bi bi-envelope fs-5" }, null, -1)
const _hoisted_13 = { class: "align-self-center ps-2 m-0" }
const _hoisted_14 = { class: "d-flex mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone text-white fs-5" }, null, -1)
const _hoisted_16 = { class: "contact align-self-center text-white ps-2 m-0" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "bi bi-patch-check fs-5" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "align-self-center ps-2 m-0" }, "View Proof of Authenticity", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-3 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary text-white fw-medium rounded-0 py-2 px-3"
  }, " Accept "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-danger fw-medium rounded-0 py-2 px-3"
  }, " Reject ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.registrant.name), 1),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.registrant.type), 1),
      _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.dateDuration), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.registrant.bio), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.registrant.address), 1)
        ]),
        _createElementVNode("a", {
          class: "email link-white link-opacity-75-hover d-flex mb-2",
          href: `mailto:${_ctx.registrant.email}`,
          target: "_blank"
        }, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.registrant.email), 1)
        ], 8, _hoisted_11),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.registrant.contact), 1)
        ]),
        _createElementVNode("a", {
          class: "proof link-white link-opacity-75-hover d-flex mb-2",
          href: _ctx.registrant.proof,
          target: "_blank"
        }, _hoisted_20, 8, _hoisted_17),
        _hoisted_21
      ])
    ])
  ]))
}